import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// ============================================================================
// ✅ CONFIGURATION i18n — PRODUCTION READY, SAFE & SCALABLE
// ============================================================================

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // ------------------------------------------------------------------------
    // 🌍 LANGUES
    // ------------------------------------------------------------------------

    // ❗ On laisse le LanguageDetector décider
    // et on sécurise avec un fallback solide
    fallbackLng: ['fr-FR'],
    preload: ['fr-FR', 'en-US'],
    load: 'currentOnly',

    // ------------------------------------------------------------------------
    // 📦 NAMESPACES
    // ------------------------------------------------------------------------

    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'products',
      'chat',
      'payments',
      'shipping',
      'stories',
      'events',
      'referral',
      'emails',
      'errors',
      'validation',
      'preferences-common',
      'profiles-adults',
      'profiles-business',
      'profiles-children',
      'profiles',
      'growth',
      'sizes',
      'subscription',
      'cart',
      'checkout',
      'categories',
      'shop',
    ],

    // ------------------------------------------------------------------------
    // 📡 BACKEND
    // ------------------------------------------------------------------------

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__I18N_BUILD_TS__}`,
    },

    // ------------------------------------------------------------------------
    // 🕵️ DÉTECTION DE LANGUE
    // ------------------------------------------------------------------------

    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',

      // Mapping strict vers les locales réellement supportées
      convertDetectedLanguage: (lng: string): string => {
        const languageMap: Record<string, string> = {
          en: 'en-US',
          'en-GB': 'en-US',
          'en-CA': 'en-US',
          'en-US': 'en-US',

          fr: 'fr-FR',
          'fr-CA': 'fr-FR',
          'fr-FR': 'fr-FR',

          de: 'de-DE',
          'de-AT': 'de-DE',
          'de-DE': 'de-DE',

          es: 'es-ES',
          'es-MX': 'es-ES',
          'es-ES': 'es-ES',

          it: 'it-IT',
          'it-IT': 'it-IT',

          nl: 'nl-NL',
          'nl-NL': 'nl-NL',

          pl: 'pl-PL',
          'pl-PL': 'pl-PL',

          cs: 'cs-CZ',
          'cs-CZ': 'cs-CZ',

          lt: 'lt-LT',
          'lt-LT': 'lt-LT',
        };

        const mappedLang = languageMap[lng] || 'fr-FR';

        // Sauvegarde explicite et immédiate
        localStorage.setItem('i18nextLng', mappedLang);

        return mappedLang;
      },
    },

    // ------------------------------------------------------------------------
    // 🔁 FALLBACK & SÉCURITÉ
    // ------------------------------------------------------------------------

    // Empêche null / string vide si clé manquante
    returnNull: false,
    returnEmptyString: false,

    // ------------------------------------------------------------------------
    // 🧩 INTERPOLATION
    // ------------------------------------------------------------------------

    interpolation: {
      escapeValue: false,
    },

    // ------------------------------------------------------------------------
    // ⚛️ REACT
    // ------------------------------------------------------------------------

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
    },

    // ------------------------------------------------------------------------
    // 🧪 DEBUG
    // ------------------------------------------------------------------------

    debug: import.meta.env.DEV,
  })
  .then(() => {
    // Synchronisation locale à chaque changement
    i18n.on('languageChanged', lng => {
      localStorage.setItem('i18nextLng', lng);
    });
  })
  .catch(error => {
    console.error('❌ Erreur initialisation i18n:', error);
  });

export default i18n;
